/* eslint-disable react/no-array-index-key */
import { Button } from '@mui/material';
import { Grid } from '@mui/system';
import { useNavigate } from 'react-router-dom';

function ScheduleAppointment({ scheduleData }) {
  const navigate = useNavigate();

  const handleNavigation = (url) => {
    navigate(url);
  };
  return (
    <Grid className="scheduleAppointment-section-wrap">
      <Grid container className="section-content" sx={{ justifyContent: 'space-between' }}>
        <Grid size={{ sm: 8, md: 6 }} sx={{ justifyContent: 'center', py: 4 }}>
          <h2 className="title">{scheduleData?.title}</h2>
          <p className="subtitle">
            {scheduleData?.description}
          </p>
          <div className="buttons-wrap">
            <Button size="large" variant={scheduleData?.buttonsList[0].variant || 'contained'} onClick={() => handleNavigation('/contact-us')}>{scheduleData?.buttonsList[0]?.label?.slice(0, 25) }</Button>
            <Button size="large" variant={scheduleData?.buttonsList[1].variant || 'contained'} onClick={() => handleNavigation('/about')}>{scheduleData?.buttonsList[1]?.label?.slice(0, 25) }</Button>
          </div>
        </Grid>
        <Grid justifyContent={'center'} sx={{ display: { xs: 'none', md: 'flex' } }}>
          <img
            src={scheduleData?.backgroundImage?.url}
            alt={scheduleData?.backgroundImage?.alt || 'Schedule appointment illustration'}
            className="schedule-image"
          />
        </Grid>
      </Grid>
      <Grid />
    </Grid>

  );
}

export default ScheduleAppointment;
